<template>
    <input type="hidden" name="_token" :value="csrf" />
    <input type="hidden" name="_cart" :value="cartEncoded" />

    <CheckoutCart
        :checkout-add-ons-enabled="checkoutAddOnsEnabled"
        :checkout-add-ons="checkoutAddOns"
    ></CheckoutCart>
    <CheckoutForm v-if="cartItems.length > 0" :defaults="merged"></CheckoutForm>
</template>

<script setup>
import {computed, onMounted, watch} from 'vue'
import { useCart } from '@/frontend/vue/composables/useCart'
import CheckoutCart from './CheckoutCart.vue'
import CheckoutForm from './CheckoutForm.vue'

const props = defineProps({
    defaults: { type: Object, default: () => ({}) },
    first : { type: String, default : "" },
    last : { type: String, default : "" },
    email : { type: String, default : "" },
    phone : { type: String, default : "" },
    address : { type: String, default : "" },
    suburb : { type: String, default : "" },
    state : { type: String, default : "" },
    postcode : { type: String, default : "" },
    checkoutAddOnsEnabled: { type: [Boolean, String, Number], default: false },
    checkoutAddOns: { type: [Array, String], default: () => [] },
})

const checkoutAddOnsEnabled = computed(() =>
    props.checkoutAddOnsEnabled === true
    || props.checkoutAddOnsEnabled === 1
    || props.checkoutAddOnsEnabled === '1'
    || props.checkoutAddOnsEnabled === 'true'
)

const checkoutAddOns = computed(() => {
    if (Array.isArray(props.checkoutAddOns)) {
        return props.checkoutAddOns
    }

    try {
        return JSON.parse(props.checkoutAddOns || '[]')
    } catch {
        return []
    }
})

const merged = computed(() => ({
    firstName: props.first,
    lastName:props.last,
    email: props.email,
    phone: props.phone,
    address: props.address,
    suburb: props.suburb,
    state: props.state,
    postcode: props.postcode,
}))

const { cartItems, saveCart } = useCart()
const { defaults } = props

const cartJson = computed(() =>
    JSON.stringify(
        cartItems.value.map(item => ({
            id: item.id,
            type: item.type,
            quantity: item.quantity,
            price: item.price,
            variant: item.variant,
            code: item.code
        }))
    )
)

const csrf = document.querySelector('meta[name="_token"]').getAttribute('content')
const cartEncoded = computed(() => { return btoa(cartJson.value) })
const checkoutElement = document.querySelector('.checkout')

watch(
    () => cartItems.value.length,
    (length) => {
        checkoutElement?.classList.toggle('checkout--has-items', length > 0)
    },
    { immediate: true }
)

onMounted(async () => {
   // Refresh cart data from server to get updated max_quantity values
   saveCart();
});

</script>
